export const Jpg = ({
  size = "20",
  ...props
}: { size?: string } & React.SVGProps<SVGSVGElement>) => {
  return (
    <>
      <span className="t-sr-only">Jpg</span>
      <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M8.125 15.625H9.375C9.70652 15.625 10.0245 15.4933 10.2589 15.2589C10.4933 15.0245 10.625 14.7065 10.625 14.375C10.625 14.0435 10.4933 13.7255 10.2589 13.4911C10.0245 13.2567 9.70652 13.125 9.375 13.125H8.125V15V16.875"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.625 13.125V15.625C5.625 15.9565 5.4933 16.2745 5.25888 16.5089C5.02446 16.7433 4.70652 16.875 4.375 16.875C4.04348 16.875 3.72554 16.7433 3.49112 16.5089C3.2567 16.2745 3.125 15.9565 3.125 15.625"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.6875 15.1563H15.625V16.0781C15.4765 16.3185 15.2698 16.5175 15.024 16.6568C14.7782 16.7961 14.5013 16.8712 14.2188 16.875C13.2656 16.875 12.5 16.0391 12.5 15C12.5 13.9609 13.2656 13.125 14.2188 13.125C14.5557 13.1244 14.884 13.2311 15.1562 13.4297"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.75 10V3.125C3.75 2.95924 3.81585 2.80027 3.93306 2.68306C4.05027 2.56585 4.20924 2.5 4.375 2.5H11.875L16.25 6.875V10"
          fill="#EE82A3"
        />
        <path d="M11.875 2.5V6.875H16.25" fill="#BF517A" />
      </svg>
    </>
  );
};
